import {createSelector} from 'reselect';
import {createResourceSelector} from 'src/shared/utils/resource';

export const currentBillSummary = createResourceSelector('currentBillSummary');

export const delinquent = createSelector(
  currentBillSummary,
  currentBillSummary => currentBillSummary?.delinquency?.delinquencyStatus === 'DELINQUENT'
);

export const eligibleForPromiseToPay = createSelector(
  currentBillSummary,
  currentBillSummary => !!currentBillSummary?.promiseToPay?.promiseToPayDate
);

export const inSoftDisconnect = createSelector(
  currentBillSummary,
  currentBillSummary => currentBillSummary?.delinquency?.softDisconnected || false
);

export const paymentsUpToDate = createSelector(
  [delinquent, eligibleForPromiseToPay, inSoftDisconnect],
  (delinquent, eligibleForPromiseToPay, inSoftDisconnect) =>
    !delinquent
    && !eligibleForPromiseToPay
    && !inSoftDisconnect
);

export const pastDueBalance = createSelector(
  currentBillSummary,
  currentBillSummary => currentBillSummary.pastDueBalance
);

export const dueDate = createSelector(
  currentBillSummary,
  currentBillSummary => currentBillSummary.dueDate
);
